/**
 * Actions supported by this application
 * the UI will only render the actions
 * that have truthy values here.
 **/
export const SUPPORTED_ACTIONS = {
  billing_details: true,
  cancel: true,
  change_crew: true,
  change_my_pro: true,
  change_frequency: true,
  contact_lawnstarter: true,
  crew_no_show: true,
  included_with_mowing: true,
  long_grass_fee: true,
  message_crew: true,
  mmnwd: true,
  one_time_reschedule: true,
  order_services: true,
  pause: true,
  payment_info: true,
  property_damage: true,
  share: true,
  skip: true,
  three_cut_min: true,
  trust_fee: true,
};

export const ACTION_ROUTE_MAP = {
  billing_details: 'billing',
  change_crew: 'changeMyProvider',
  change_my_pro: 'changeMyProvider',
  contact_lawnstarter: 'messageLS',
  crew_no_show: 'crewNoShow',
  included_with_mowing: 'whatsIncluded',
  message_crew: 'specialInstructions',
  one_time_reschedule: 'oneTimeReschedule',
  order_services: 'whatOtherServices',
  pause: 'pauseSubscription',
  property_damage: 'propertyDamage',
  share: 'share',
  skip: 'skipMow',
};

export const ACTION_METHOD_MAP = {
  change_frequency: 'changeFrequency',
  long_grass_fee: 'openLongGrassFee',
  mmnwd: 'disputeMow',
  payment_info: 'openPayment',
  three_cut_min: 'openThreeCutMin',
  trust_fee: 'openTrustFee',
  cancel: 'cancelSubscription',
};

// here is where we define order
export const ACTIONS_BY_CATEGORY = {
  modifyServices: ['pause', 'cancel', 'skip', 'change_frequency', 'one_time_reschedule'],
  reportAnIssue: ['property_damage', 'mmnwd', 'crew_no_show', 'change_crew', 'change_my_pro'],
  other: [
    'message_crew',
    'billing_details',
    'payment_info',
    'long_grass_fee',
    'three_cut_min',
    'order_services',
    'contact_lawnstarter',
    'share',
    'get_app',
    'included_with_mowing',
    'trust_fee',
  ],
};

export const BRAND_SUPPORT_ARTICLES_URLS = {
  lawnstarter: {
    longGrassFee: '12698339688850-Customer-Policy-FAQs#h_01H93Y0N2GG8P6T76QVD4NV5SK',
    threeCutPolicy: '12698339688850-Customer-Policy-FAQs#h_01H93Y04M37R61R6AVZK9PD9JT',
    trustAndSafetyFee: '12698339688850-Customer-Policy-FAQs#h_01H93Y160TWSFC43WAPYEH2DKZ',
  },
  lawnlove: {
    longGrassFee: '12698339688850-Customer-Policy-FAQs#h_01H93XX8XS445T76E0YTP8YRPX',
    threeCutPolicy: '12698339688850-Customer-Policy-FAQs#h_01H93XWW8KPZZHYP5J6FY15HET',
    trustAndSafetyFee: '12698339688850-Customer-Policy-FAQs#h_01H93XYTPCS8ZS62X8TZZ9AM5P',
  },
};
